import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView'
 
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    // beforeEnter:(to,from,next)=>{
    //   console.log('beforeEnter',to,from,next);
    //   console.log('浏览器宽度', document.documentElement.offsetWidth|| document.body.offsetWidth)
    //   next();
    // }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/ProductView')
  },
  {
   path:'/news',
   name:'news',
   component:()=> import('../views/NewsView')
  },
  {
    path:'/contact',
    name:'contact',
    component:()=> import('../views/ContactView')
   },
   {
    path:'/NewsDetail',
    name:'newsdetail',
    component:()=> import('../views/NewsDetail')
   },
   {
    path:'/ProductDetail',
    name:'productdetail',
    component:()=> import('../views/ProductDetail')
   },
   {
    path:'/ProductNewDetail',
    name:'productnewdetail',
    component:()=> import('../views/ProductNewDetail') //第2版产品详情页面
   },
   {
    path:'/CompanyHistory', //历史沿革(第2版开始使用大驼峰)
    name:'companyhistory',
    component:()=> import('../views/CompanyHistory')
   },
   {
    path:'/CompanyHonor', //资质荣誉
    name:'companyhonor',
    component:()=> import('../views/CompanyHonor')
   },
   {
    path:'/CompanyStaff', //员工风采
    name:'companystaff',
    component:()=> import('../views/CompanyStaff')
   },
    {
    path:'/CompanyCustomer', //合作客户
    name:'companycustomer',
    component:()=> import('../views/CompanyCustomer')
   },
   {
    path:'/NewsPersonCare', //人文关怀
    name:'newspersoncare',
    component:()=> import('../views/NewsPersonCare')
   },
   {
    path:'/ProductTrace', //逐支跟踪
    name:'producttrace',
    component:()=> import('../views/ProductTrace')
   },
   {
    path:'/ProductTv', //集控中心
    name:'producttv',
    component:()=> import('../views/ProductTv')
   },
   {
    path:'/ProductCheck', //管端尺寸检测设备
    name:'productcheck',
    component:()=> import('../views/ProductCheck')
   },
   {
    path:'/ProductPolish', //管端自动打磨系统
    name:'productpolish',
    component:()=> import('../views/ProductPolish')
   },
   {
    path:'/ProductInOut', //内表面缺陷检测设备
    name:'productinout',
    component:()=> import('../views/ProductInOut')
   },
   {
    path:'/ProductPing', //平直度检测设备
    name:'productping',
    component:()=> import('../views/ProductPing')
   },
   {
    path:'/ProductTrack', //逐支跟踪系统(新)
    name:'producttrack',
    component:()=> import('../views/ProductTrack')
   },
   {
    path:'/ProductControl', //集控中心(新)
    name:'productcontrol',
    component:()=> import('../views/ProductControl')
   }
]

const router = new VueRouter({
  mode: 'history',
  // base:'/Jyzk',
  routes,
  scrollBehavior(){
   return {x:0,y:0}
  }
})

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
